import { useEffect, useRef, useState } from 'react'

// Mounts children only once the wrapper scrolls into view (IntersectionObserver, threshold 0.1).
// Until then it renders a placeholder div that keeps the section's id, so scrollToSection
// (sidebar / mobile pill nav) still jumps to the right position before the inner content mounts.
const LazySection = ({ id, children, rootMargin = '200px', placeholderMinHeight = 200 }) => {
  const [visible, setVisible] = useState(false)
  const placeholderRef = useRef(null)

  useEffect(() => {
    if (visible) return
    const el = placeholderRef.current
    if (!el) return
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true)
          observer.disconnect()
        }
      },
      { threshold: 0.01, rootMargin }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [visible, rootMargin])

  if (visible) return children

  return (
    <div
      id={id}
      ref={placeholderRef}
      style={{ minHeight: placeholderMinHeight }}
      className="scroll-mt-40 min-[992px]:scroll-mt-20"
    />
  )
}

export default LazySection
